import { InputLabel as MUIInputLabel, InputLabelProps } from '@mui/material';

export { type InputLabelProps } from '@mui/material';

export function InputLabel(props: InputLabelProps) {
  return <MUIInputLabel {...props} />;
}
